import RichText from "@/components/RichText";
import MutedVideo from "../components/MutedVideo";
import { CONTAINER, DARK_BG, EYEBROW_DARK, H1_HERO, OVERLAY_HERO, RULE_DARK } from "../tokens";

// Héro vidéo de l'accueil : vidéo de l'atelier en fond (object-fit cover,
// opacité .72) + dégradé latéral, contenu aligné bas-gauche, entrée en
// fondu (translateY 10px → 0, 0,9 s).
export default function HeroVideoSection({ props = {} }) {
  return (
    <section className="relative min-h-[520px] flex items-end overflow-hidden" style={DARK_BG}>
      <MutedVideo
        src={props.video_url}
        poster={props.poster_image}
        opacity={0.72}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0" style={{ background: OVERLAY_HERO }} aria-hidden="true" />
      <div className={`${CONTAINER} relative`}>
      <div className="px-5 md:px-11 pt-[72px] pb-14 max-w-[760px] animate-rise-soft">
        <RichText as="div" className={EYEBROW_DARK} html={props.eyebrow} />
        <RichText
          as="h1"
          className={`${H1_HERO} text-[clamp(34px,5vw,58px)] leading-[1.08] mt-[22px] [text-wrap:balance]`}
          html={props.heading}
        />
        <span className={`${RULE_DARK} mt-[30px] mb-5`} aria-hidden="true" />
        {props.tagline && (
          <div className="text-[11px] tracking-[0.24em] uppercase text-cream/[0.85] leading-[2]">
            {props.tagline}
          </div>
        )}
      </div>
      </div>
    </section>
  );
}
